import React, { ReactElement } from 'react';
import TableRow from '../table-row/table-row.component';
import TableCell from '../table-cell/table-cell.component';
import ActionButtonNewItem from '../action-button-new-item/action-button-new-item.component';
import FormatService from '../../services/format-service';
import useStylesTableRowAddNewItem from './table-row-add-new-item.styles';

const TableRowAddNewItem: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COL_SPAN_BUTTON_DEFAULT: number = 1;

  const {
    isLight,
    isSticky,
    colSpan,
    label,
    className,
    onClick,
  } = props;

  const { classes } = useStylesTableRowAddNewItem();

  return (
    <TableRow className={FormatService.formatClassNames(classes.tableRowAddNewItem, className)}>
      <TableCell
        isButton
        isTextLeft
        isSticky={isSticky}
        isStickyLeft={isSticky}
        colSpan={!isSticky ? colSpan : COL_SPAN_BUTTON_DEFAULT}
        className={isSticky ? classes.tableCellSticky : undefined}
        onClick={onClick}
      >
        <ActionButtonNewItem withNoHighlight isLight={isLight} label={label} />
      </TableCell>
      {
        isSticky && (
          <TableCell colSpan={colSpan - 1} />
        )
      }
    </TableRow>
  );
});

export default TableRowAddNewItem;
